import { render, staticRenderFns } from "./chipwithrole.vue?vue&type=template&id=0fa37d5f&scoped=true"
import script from "./chipwithrole.vue?vue&type=script&lang=js"
export * from "./chipwithrole.vue?vue&type=script&lang=js"
import style0 from "./chipwithrole.vue?vue&type=style&index=0&id=0fa37d5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa37d5f",
  null
  
)

export default component.exports